import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { colors } from '../../config/constants';

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 1vw;
  margin: auto;
  padding-bottom: 1vw;
  min-height: fit-content;
  background-color: ${colors.COLOR_BACKGROUND}
`;

const BaconLogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    max-width: 150px;
  }
  p {
    font-size: 1.3em;
  }
  margin-bottom: 10px;
`;

export const BaconStopContainer = styled.div`
  width: 100%;
  flex-direction: column;
  img {
    max-width: 250px;
  }
  align-items: center;
  padding-left: 2vw;
  margin-top: 10px;
`;

const BottomText = styled.p`
  margin-top: 25px;
  margin-bottom: 0px;
  font-size: 13px;
`;

const Box = ({ children, status, bottomText }) => {

  const LogoContainer = status === 'error' ? BaconStopContainer : BaconLogoContainer;
  const logo = status === 'error' ? 'bacon_stop.svg' : 'bacon_icon_outline.png';

  return (
    <BoxContainer>
      <LogoContainer>
        <img
          src={`${process.env.PUBLIC_URL}/images/${logo}`}
          alt="Bacon logo"
        />
      </LogoContainer>
      {children}
      <BottomText>{bottomText}</BottomText>
    </BoxContainer>
  );
};

Box.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  bottomText: PropTypes.string,
  status: PropTypes.string,
};

Box.defaultProps = {
  logoContainer: BaconLogoContainer,
};

export default Box;